// extracted by mini-css-extract-plugin
export default {"socialMenu":"SocialMenu_socialMenu__IognU"};